import { SET_VIEW, RESET_REDUX, SET_MAIN_VIEW_SECTION } from "../actions/index";
import { viewIds, mainAppSectionIds } from "../constants/componentMap";
import produce from "immer";

const initialState = {
  viewId: viewIds.startPage,
  mainViewSection: {
    orientation: "CENTER",
    columnOne: null,
    columnTwo: mainAppSectionIds.locationSection,
    columnThree: mainAppSectionIds.sampleSection,
    columnFour: null,
  },
};
// Changing default view for dev purposes studyNewStudy -> mainApp
export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_VIEW: {
        draft.viewId = action.viewId;
        break;
      }
      case SET_MAIN_VIEW_SECTION: {
        draft.mainViewSection.orientation = action.orientation;
        draft.mainViewSection.columnOne = action.columnOne;
        draft.mainViewSection.columnTwo = action.columnTwo;
        draft.mainViewSection.columnThree = action.columnThree;
        draft.mainViewSection.columnFour = action.columnFour;
        break;
      }
      case RESET_REDUX:
        if (action.keepUser) {
          draft.viewId = viewIds.startPage;
          draft.mainViewSection = initialState.mainViewSection;
        } else {
          draft.viewId = viewIds.loginPage;
          draft.mainViewSection = initialState.mainViewSection;
        }
        break;

      default:
        return draft;
    }
  });
